export function useMenuOpenStyles(menuOpen: boolean): {
  lineStyle: string
  navbarStyle: string
  overlayStyle: string
  textStyle: string
} {
  const lineStyle = menuOpen
    ? 'menuButton__line  menuButton__line--active'
    : ' menuButton__line'

  const navbarStyle = menuOpen
    ? 'navbar__options navbar__options--open'
    : 'navbar__options'

  const overlayStyle = menuOpen
    ? 'navbar__overlay navbar__overlay--active'
    : 'navbar__overlay'

  const textStyle = menuOpen ? 'navbar__text' : 'navbar__text tab'

  return { lineStyle, navbarStyle, overlayStyle, textStyle }
}
